// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getBeginWeeks, getEndWeeks
} from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import NoBundlesOrderedTable from './components/no-bundles-ordered-table';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import getNoBundlesOrdered from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class NoBundlesOrdered extends Component {

    state = {
        beginWeeks: [],
        endWeeks: [],
        selectedBeginWeek: '',
        selectedEndWeek: '',
        results: null
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getBeginWeeks( ).then( response => {

            const bWeeks = response.map( i => {

                const wk = formatGivenDate( i.beginWeek, 'YYYY-MM-DD' );
                let wkn = wk;
                if ( wk === '2000-01-01' ) wkn = 'Inventory';
                if ( wk === '2000-02-01' ) wkn = 'Rework';
                return { id: wk, value: wkn };

            } );
            this.setState( {
                beginWeeks: bWeeks
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val,
            selectedEndWeek: ''
        } );
        this.props.increaseCounter();
        getEndWeeks( val ).then( response => {

            const eWeeks = response.map( i => {

                const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                let wkn = wk;
                if ( wk === '2000-01-01' ) wkn = 'Inventory';
                if ( wk === '2000-02-01' ) wkn = 'Rework';
                return { id: wk, value: wkn };

            } );
            this.setState( {
                endWeeks: eWeeks,
                selectedEndWeek: '',
                results: null
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        this.props.increaseCounter();
        const limit = 100;
        getNoBundlesOrdered( this.state.selectedBeginWeek, this.state.selectedEndWeek, limit )
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            selectedBeginWeek, selectedEndWeek, beginWeeks, endWeeks, results
        } = this.state;

        const fullRes = results;

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">No Bundles Ordered</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-no-bundles-ordered-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-no-bundles-ordered-select"
                                    label="Begin Week"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleBeginWeekChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={beginWeeks}
                                    placeholder="Select Begin Week"
                                    selectedValue={selectedBeginWeek}
                                />
                                {selectedBeginWeek && (
                                    <OptionsDropDown
                                        className="atp-no-bundles-ordered-select"
                                        label="End Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={endWeeks}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                    />
                                )}
                                {selectedBeginWeek && selectedEndWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        {selectedBeginWeek && selectedEndWeek && fullRes && (
                            <NoBundlesOrderedTable
                                results={fullRes}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

NoBundlesOrdered.displayName = 'NoBundlesOrdered';
NoBundlesOrdered.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( NoBundlesOrdered ) );
